/**
 * PATH: packages/job-hub/src/jobs/qa/itpBrandLockup.tsx
 * FILE_ID: JOBHUB-QA-ITP-BRAND-001
 * PURPOSE: Centered org logo, then Powered by beside Quotech, for ITP screen and Print.
 * WHY: Print is srcdoc; screen reads the tenant bootstrap brand slot.
 */
import { clampLogoDisplayHeightPx } from '@quotech/quote-builder'
import { getQuoteBuilderQuoteBrand, useQuoteBrand } from '@quotech/quote-builder/runtime/quoteBrand'
import quotechLockupUrl from './assets/quotech-powered-by.png'

function escapeAttr(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function readItpOrgLogoSrc(): string {
  const brand = getQuoteBuilderQuoteBrand()
  return (brand.logoDataUri || brand.logoUrl || '').trim()
}

export function readItpOrgLogoHeightPx(): number {
  return clampLogoDisplayHeightPx(getQuoteBuilderQuoteBrand().logoDisplayHeightPx)
}

export function itpBrandLockupHtml(
  orgLogoSrc = readItpOrgLogoSrc(),
  heightPx = readItpOrgLogoHeightPx(),
  align: 'center' | 'left' = 'center',
): string {
  const logoH = clampLogoDisplayHeightPx(heightPx)
  const org = orgLogoSrc
    ? `<img class="itp-org-logo" src="${escapeAttr(orgLogoSrc)}" alt="" style="height: ${logoH}px" />`
    : ''
  const alignClass = align === 'left' ? 'itp-brand-left ' : ''
  return (
    `<div class="${alignClass}itp-brand">` +
    org +
    `<div class="itp-powered-row">` +
    `<span class="itp-powered">Powered by</span>` +
    `<img class="itp-quotech-logo" src="${escapeAttr(quotechLockupUrl)}" alt="Quotech" />` +
    `</div>` +
    `</div>`
  )
}

export function ItpBrandLockup() {
  const brand = useQuoteBrand()
  const orgSrc = (brand.logoDataUri || brand.logoUrl || '').trim()
  const logoH = clampLogoDisplayHeightPx(brand.logoDisplayHeightPx)
  return (
    <div className="itp-brand mb-3 flex w-full max-w-full flex-col items-center" data-testid="itp-brand-lockup">
      {orgSrc ? (
        <img
          src={orgSrc}
          alt={brand.companyName || ''}
          className="block w-auto max-w-full object-contain"
          style={{ height: logoH }}
        />
      ) : null}
      <div className="mt-2 flex max-w-full flex-wrap items-center justify-center gap-2">
        <div className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">Powered by</div>
        <img
          src={quotechLockupUrl}
          alt="Quotech"
          className="block h-7 w-auto max-w-full object-contain"
        />
      </div>
    </div>
  )
}
